import styled from 'styled-components'
import space from '@/client/components/theme/space'

export const WrapCalculator = styled.div`
  position: relative;
  padding-top: ${space.xl5};
`
